module.exports = __webpack_public_path__ + "img/BRCA1_CD8T.8a5be10b.png";